import { useSessao } from '../lib/sessao'
import { Topo } from '../componentes/ui'
import { AbaRecursos } from './PecasCadastro'

/**
 * Onde se atende.
 *
 * Estava no terceiro lugar de dentro de `/ajustes › agenda`, empilhada
 * abaixo da grade e das jornadas — e o passo "diga onde se atende" da
 * lista de partida apontava para `/ajustes`, sem dizer para qual grupo.
 *
 * Sala é o que faz a agenda ter onde marcar: sem nenhuma cadastrada, o
 * `POST /v1/agendamentos` não tem `alocacao` possível. Por isso ela é
 * um destino, e não uma seção enterrada.
 */
export function Salas() {
  const { pode } = useSessao()
  return (
    <>
      <Topo titulo="Salas e equipamentos"
            subtitulo="Onde e com o quê se atende. A agenda marca contra estes — sem nenhum, não há onde encaixar o paciente.">
        {!pode('config:write') && <span className="selo selo--neutro">só leitura</span>}
      </Topo>
      <AbaRecursos podeEditar={pode('config:write')} />
    </>
  )
}
